document.querySelectorAll('.card-group').forEach(group => {
  group.dataset.count = group.querySelectorAll('.card').length;
});
